import { defineComponent as _defineComponent } from 'vue'
import { type Ref, computed, ref, useRoute, useRouter, useStore } from "@nuxtjs/composition-api";

import { useAmplitude, useCategories } from "@/composables";
import { getAmplitudeStore } from "@/store/amplitude";
import { getLtksStore } from "@/store/ltks";


export default /*#__PURE__*/_defineComponent({
  __name: 'LtkPostCaption',
  props: {
  postId: { type: String, required: true },
},
  setup(__props) {

const props = __props;



const route = useRoute();
const store = useStore();
const router = useRouter();
const amplitude = useAmplitude();
const { supportedHashtags } = useCategories();

const post = computed(() => getLtksStore(store).ltks[props.postId]);
const hashtags: Ref<Array<{ to: string; text: string }>> = ref([]);
const showCaptionSheet = ref(false);

const caption = computed(() =>
  post.value
    ? {
        caption:
          (hashtags.value = []) &&
          (post.value?.caption || "").replace(
            new RegExp(`(#(${supportedHashtags.value.join("|")})\\b)`, "gi"),
            // 1: whole match, 2: hashtag name without octothorpe
            (_match, p1, p2) =>
              (hashtags.value.push({
                to: `/categories/${p2}`,
                text: p1,
              }) &&
                0) ||
              "",
          ),
        hashtags: hashtags.value,
      }
    : {
        caption: "",
        hashtags: [],
      },
);

const toggleShowCaptionSheet = () => {
  if (showCaptionSheet.value === false) {
    amplitude?.sendEvent("/post/caption/expand");
  }
  showCaptionSheet.value = !showCaptionSheet.value;
};

const hashtagClick = (to: string) => {
  const referringComp = amplitude?.getReferringComponentByPage(route.value.name ?? "", "hashtag") ?? "";
  getAmplitudeStore(store).setReferringComponent(referringComp);
  router.push(to);
};

return { __sfc: true,props, route, store, router, amplitude, supportedHashtags, post, hashtags, showCaptionSheet, caption, toggleShowCaptionSheet, hashtagClick }
}

})